///DEV environment
export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyD9HBSJrQ6eDfk4kGb8KKNymZN6fGnCUDM',
    authDomain: 'conversell-dev-b1562.firebaseapp.com',
    projectId: 'conversell-dev-b1562',
    storageBucket: 'conversell-dev-b1562.firebasestorage.app',
    messagingSenderId: '758489913965',
    appId: '1:758489913965:web:95e34cea0e58df9623bd64',
    measurementId: 'G-4N6Q0Y0Z8Z',
    databaseURL: 'https://conversell-dev-b1562-default-rtdb.firebaseio.com',
  },
  amazonSDK: {
    ClientID: 'amzn1.application-oa2-client.f565a08839c74b12841a92e725440c22',
  },
  urlFulfilmentGA:
    'https://us-central1-dev-conversell.cloudfunctions.net/fulfillment',
  urlStartedMessage:
    'https://graph.facebook.com/v21.0/me/messenger_profile?' +
    'access_token=EAACOBV7q3Q8BAOss1Rxhm8q5ZCvnmGZAuUHKmmMnOyWMDYDsRhLKn5ReLTUsojYLkZBtXgQcZC8zB1Rp6ZAnHP8u0Hz1ePsdGjLYK4hFMVZC42iD7dQ62auHYPQFQlbiboXHI5usvz1j7yFtWKnnsf11od78iZCPr5u2qzT2C1thwZDZD',
  noProfilePic:
    'https://firebasestorage.googleapis.com/v0/b/vertical-mapper-187409.appspot.com/o/utils%2Fnoprofile.png?alt=media&token=eb6c3555-3ea6-4459-8fef-0e5096c8cce1',
  urlFacets: 'https://admin.favizone.com/facets/get-facets',
  updateFacetUrl: 'https://admin.favizone.com/facets/updateFacetsData',
  updateFacetsRankUrl: 'https://admin.favizone.com/facets/updateFacetRanks',

  updateFacetsRankUr: 'https://admin.favizone.com/facets/updateFacetRanks',
  favizoneAccountUrl: 'https://admin.favizone.com/user/signupFromConversell',
  FAVIZONE_HOST: 'https://admin.favizone.com',
  FAVIZONE_HOST_WITHOUT_HTTPS: 'admin.favizone.com',
  FAVIZONE_END_POINTS: {
    UpdateBillingDataFieldsUrl: 'shop/updateBillingDataFields',
    addAccount: 'v2/user/add-account',
    addCategory: '/v2/category/add',
    importdata: 'api/update-import-data',
    connectFromConverllUrl: 'api/conversell',
  },
  FAVIZONE_TOKEN: 'RkFWSVpPTkVfUkVNT1RFX1VTRVI6d0NtazRaTidNMkh4KV9SYg==',
  urlRecommender:
    'https://us-central1-dev-conversell.cloudfunctions.net/mongoAccess',
  urlPersistentMenu: 'https://graph.facebook.com/v21.0/me/messenger_profile?',
  facebookVersion: 'v21.0',
  facebookAppSecretKey: '42976bc0c2b56f87cf4cdd1487ead0ac',
  facebookAppKey: '2488442388239297', //'1105249443543482'
  stripeClientID: 'ca_HMq2wFlqHMxJOoGCqlhG4Rw0yX2J3uzj',
  detectIntentURL:
    'https://us-central1-dev-conversell.cloudfunctions.net/detectIntent',
  shopifyDevBaseURL: 'https://us-central1-devconversell.cloudfunctions.net',
  shopifyProdBaseURL: {
    'google-assistant':
      'https://us-central1-dev-conversell.cloudfunctions.net/shopifyVoiceNotifications',
    alexa:
      ' https://us-central1-dev-conversell.cloudfunctions.net/shopifyVoiceNotifications',
    'google-assistantAdvanced':
      'https://us-central1-dev-conversell.cloudfunctions.net/shopifyGAAdmin',
    messenger:
      'https://us-central1-dev-conversell.cloudfunctions.net/shopifyConversationnalNotifications',
  },
  freeUserLimit: 200,
  shopifyPaths: {
    getCollections: '/getallcollection?shop=',
    install: 'shopify?shop=',
    updateEnabledDisableCollection: 'updateFiltredCategrory',
    billingCreate: 'billing/create',
    billingUpdate: 'billing/update',
    billingCancel: 'billing/cancel',
    getShippingZones: '/getShippingZones?shop=',
    billingCreateOnUsage: 'billing/create/subscription/basedOnUsage',
  },
  InteractionModelAlexa:
    'https://alexabackend-ysvihxfhla-uc.a.run.app/create/interactionModel',
  resizeSkillIcon: 'https://resizeiconalexa-ysvihxfhla-uc.a.run.app/resize',
  detectInteractionModelAlexa:
    'https://alexabackend-ysvihxfhla-uc.a.run.app/detect/interactionModel',
  detectIntentAlexa:
    'https://alexabackend-ysvihxfhla-uc.a.run.app/detectIntent',
  AlexaLoginUrl: 'https://alexabackend-ysvihxfhla-uc.a.run.app/auth',
  AlexaCreateSkill: 'https://alexabackend-ysvihxfhla-uc.a.run.app/create/bot',
  createIntentsAlexa:
    'https://alexabackend-ysvihxfhla-uc.a.run.app/create/intents',
  AlexaAccountLinking:
    'https://alexabackend-ysvihxfhla-uc.a.run.app/create/accountLinking',
  urlUpdateIntent: 'https://alexabackend-ysvihxfhla-uc.a.run.app/update/intent',
  UpdateIntents:
    'https://alexabackend-ysvihxfhla-uc.a.run.app/update/interactionModel',
  CreateInteractionModel:
    'https://alexabackend-ysvihxfhla-uc.a.run.app/create/interactionModel',
  deleteIntent: 'https://alexabackend-ysvihxfhla-uc.a.run.app/delete/intent',
  urlCreateBot:
    'https://us-central1-dev-conversell.cloudfunctions.net/botApis/create-bot',
  urlCloneThemeToshop:
    'https://us-central1-dev-conversell.cloudfunctions.net/CloneFromThemeToShop',
  stripeBaseURL:
    'https://us-central1-dev-conversell.cloudfunctions.net/stripeSubscription',
  stripePaths: {
    listPlans: 'list-pricing',
    listPlansByType: 'list-plans-by-type',
    getPrimamryPlansByType: 'get-primary-plan-by-type',
    getPlanByID: 'get-price-by-id',
    install: 'shopify?shop=',
    home: '?shop=',
    createCustomer: 'create-customer',
    createSubscription: 'create-subscription',
    createCustomerPortalSession: 'create-customer-portal-session',
    upgradeSubscription: 'upgrade-subscription',
    cancelSubscription: 'cancel-subscription',
    billingSessionUrl: 'billing-session-url',
    getPlansByChannalTtype: '/get-plans-by-channal-type',
  },
  canals: [
    {
      name: 'Google Assistant',
      id: 'google-assistant',
      image:
        'https://firebasestorage.googleapis.com/v0/b/dev-conversell.appspot.com/o/general%2Fgoogle-assistant.png?alt=media&token=a291850b-9114-4e38-863e-0cab85dd83f2',
    },
    {
      name: 'Facebook Messenger',
      id: 'messenger',
      image:
        'https://firebasestorage.googleapis.com/v0/b/dev-conversell.appspot.com/o/general%2Fmessenger_logo.png?alt=media&token=ef01e683-92ae-411a-96e4-52040e78f83e',
    },
    {
      name: 'Amazon Alexa',
      id: 'alexa',
      image:
        'https://firebasestorage.googleapis.com/v0/b/dev-conversell.appspot.com/o/general%2Falexa.png?alt=media&token=5e097f89-9ae3-4b0f-9e5b-fdb983648429',
    },
  ],
  verifyAuthState:
    'https://us-central1-dev-conversell.cloudfunctions.net/conversellAuthentification/auth/getway/verify',
  sendEmailApi:
    'https://us-central1-dev-conversell.cloudfunctions.net/sendEmail',
  actionWithoutConfig: [
    'PAYLOAD_ABANDON_CART',
    'PAYLOAD_BACK_TO_LIST',
    'PAYLOAD_DEFAULT_RESPONSE',
    'PAYLOAD_DELETE_CART',
    'PAYLOAD_DELIVERY_ADRESS',
    'PAYLOAD_FILTER',
    'PAYLOAD_FUNCTIONALITY_NOT_AVAILABLE',
    'PAYLOAD_KEEP_CART',
    'PAYLOAD_OUT_OF_STOCK',
    'PAYLOAD_REPEAT_ORDER',
    'PAYLOAD_REPLAY_INFORMATION',
    'PAYLOAD_TRACK_ORDER',
    'PAYLOAD_SKIP',
    'PAYLOAD_SIGNIN',
    'PAYLOAD_SHOW_OPTIONS',
    'PAYLOAD_SHOW_OPTIONS',
  ],
  ingestKnowledgeBase: 'https://ingest.dev.conversell.ai',
  elgenKnowledgeBase: 'https://elgen.dev.conversell.ai',
  createFunctionTemplate:
    'https://us-central1-conversell-pfe.cloudfunctions.net/openAIChat/api/createFunction',
  scheduleCronjobUrl:
    'https://us-central1-dev-conversell.cloudfunctions.net/scheduleCronjob/start-cron',
  simulationUrl:
    'https://us-central1-dev-conversell.cloudfunctions.net/openAIChat/api/simulationModeDebug',
  /** Firebase Hosting site for widget-react iframe preview (matches .firebaserc target widgetiframe). */
  widgetIframeOrigin:
    'https://widgetiframeconversell-dev-b1562.firebaseapp.com',
  modelsUrl:
    'https://conversell-gateway-9og1b78t.uc.gateway.dev/botmanager/getModels',
  workspaceUrl: 'https://conversell-gateway-9og1b78t.uc.gateway.dev',
  userManagerUrl:
    'https://conversell-gateway-9og1b78t.uc.gateway.dev/usermanager/',
  platformsManagerUrl:
    'https://conversell-gateway-9og1b78t.uc.gateway.dev/platformsmanager',
  botManagerUrl:
    'https://conversell-gateway-9og1b78t.uc.gateway.dev/botmanager',
  /** Local UI fixtures for Entry Points when BotManager is offline. */
  entryPointsMock: false,
  /** CallManager HTTP (SIP admin + STT/TTS). Cloud Run us-central1. */
  callManagerUrl: 'https://callbot-758489913965.us-central1.run.app',
  callManager: 'https://conversell-gateway-9og1b78t.uc.gateway.dev',
  /**
   * ChannelManager root (POST /manage_channel). Used by the admin Policy Enforcement screen to
   * replay a synthetic messaging_policy_enforcement notice through the real webhook path.
   */
  channelManagerUrl: 'https://channelmanager-758489913965.us-central1.run.app',
  jambonzSipDomain: 'conversell.sip.jambonz.cloud',
  //stripeManagerUrl: 'https://conversell-gateway-9og1b78t.uc.gateway.dev',
  stripeManagerUrl: `https://conversell-gateway-9og1b78t.uc.gateway.dev`,
  WidgetChatManager: 'https://conversell-gateway-9og1b78t.uc.gateway.dev',
  KnowledgeBaseManager:
    'https://conversell-gateway-9og1b78t.uc.gateway.dev/knowledge-base',
  catalogManager: 'https://conversell-gateway-9og1b78t.uc.gateway.dev',
  administratorManager:
    'https://conversell-gateway-9og1b78t.uc.gateway.dev/admin',
  plansWoocommerceSubscriptionUrl: {
    createSubscriptionUrl:
      'https://us-central1-dev-conversell.cloudfunctions.net/stripeSubscription/create-subscription',
    updateSubscriptionUrl:
      'https://us-central1-prodconversell.cloudfunctions.net/stripeSubscription/update-subscription',
    cancelSubscriptionUrl:
      'https://us-central1-prodconversell.cloudfunctions.net/stripeSubscription/cancel-subscription',
  },
  localStorage: {
    user: 'conversell-user',
    secretKey: 'Conversell-Dashboard-2024-Secret-Key-Change-In-Production',
  },
};

// ///PROD environment
// export const environment = {
//   production: true,
//   firebase: {
//     apiKey: 'AIzaSyBm0Ngwu_9DGfDNTvqZllpNT1eyZzGE8YU',
//     authDomain: 'conversell-3a451.firebaseapp.com',
//     projectId: 'conversell-3a451',
//     storageBucket: 'conversell-3a451.firebasestorage.app',
//     messagingSenderId: '1031296108930',
//     appId: '1:1031296108930:web:e6395eecae574781d7679b',
//     measurementId: 'G-61GMMRQD7N',
//     databaseURL: 'https://conversell-3a451-default-rtdb.firebaseio.com',
//   },
//   amazonSDK: {
//     ClientID: 'amzn1.application-oa2-client.f565a08839c74b12841a92e725440c22',
//   },
//   urlFulfilmentGA:
//     'https://us-central1-dev-conversell.cloudfunctions.net/fulfillment',
//   urlStartedMessage:
//     'https://graph.facebook.com/v21.0/me/messenger_profile?' +
//     'access_token=EAACOBV7q3Q8BAOss1Rxhm8q5ZCvnmGZAuUHKmmMnOyWMDYDsRhLKn5ReLTUsojYLkZBtXgQcZC8zB1Rp6ZAnHP8u0Hz1ePsdGjLYK4hFMVZC42iD7dQ62auHYPQFQlbiboXHI5usvz1j7yFtWKnnsf11od78iZCPr5u2qzT2C1thwZDZD',
//   noProfilePic:
//     'https://firebasestorage.googleapis.com/v0/b/vertical-mapper-187409.appspot.com/o/utils%2Fnoprofile.png?alt=media&token=eb6c3555-3ea6-4459-8fef-0e5096c8cce1',
//   urlFacets: 'https://admin.favizone.com/facets/get-facets',
//   updateFacetUrl: 'https://admin.favizone.com/facets/updateFacetsData',
//   updateFacetsRankUrl: 'https://admin.favizone.com/facets/updateFacetRanks',
//   urlUpdateIntent: 'https://alexabackend-rcipzn3pdq-uc.a.run.app/update/intent',
//   UpdateIntents:
//     'https://alexabackend-rcipzn3pdq-uc.a.run.app/update/interactionModel',
//   CreateInteractionModel:
//     'https://alexabackend-rcipzn3pdq-uc.a.run.app/create/interactionModel',
//   deleteIntent: 'https://alexabackend-rcipzn3pdq-uc.a.run.app/deleteIntent',
//   updateFacetsRankUr: 'https://admin.favizone.com/facets/updateFacetRanks',
//   favizoneAccountUrl: 'https://admin.favizone.com/user/signupFromConversell',
//   FAVIZONE_HOST: 'https://admin.favizone.com',
//   FAVIZONE_HOST_WITHOUT_HTTPS: 'admin.favizone.com',
//   FAVIZONE_END_POINTS: {
//     UpdateBillingDataFieldsUrl: 'shop/updateBillingDataFields',
//     addAccount: 'v2/user/add-account',
//     addCategory: '/v2/category/add',
//     importdata: 'api/update-import-data',
//     connectFromConverllUrl: 'api/conversell',
//   },
//   FAVIZONE_TOKEN: 'RkFWSVpPTkVfUkVNT1RFX1VTRVI6d0NtazRaTidNMkh4KV9SYg==',
//   urlRecommender:
//     'https://us-central1-dev-conversell.cloudfunctions.net/mongoAccess',
//   urlPersistentMenu: 'https://graph.facebook.com/v21.0/me/messenger_profile?',
//   facebookVersion: 'v21.0',
//   facebookAppSecretKey: 'dcaa199fd0ff4b473f67adc25e53f043',
//   facebookAppKey: '1604703757738273',
//   /** Facebook Login for Business configuration ID (WhatsApp Embedded Signup v4). */
//   whatsappEmbeddedSignupConfigId: '1641521850880776',
//   stripeClientID: 'ca_HMq2wFlqHMxJOoGCqlhG4Rw0yX2J3uzj',
//   detectIntentURL:
//     'https://us-central1-dev-conversell.cloudfunctions.net/detectIntent',
//   shopifyDevBaseURL: 'https://us-central1-devconversell.cloudfunctions.net',
//   shopifyProdBaseURL: {
//     'google-assistant':
//       'https://us-central1-dev-conversell.cloudfunctions.net/shopifyVoiceNotifications',
//     alexa:
//       ' https://us-central1-dev-conversell.cloudfunctions.net/shopifyVoiceNotifications',
//     'google-assistantAdvanced':
//       'https://us-central1-dev-conversell.cloudfunctions.net/shopifyGAAdmin',
//     messenger:
//       'https://us-central1-dev-conversell.cloudfunctions.net/shopifyConversationnalNotifications',
//     instagram:
//       'https://us-central1-dev-conversell.cloudfunctions.net/shopifyConversationnalNotifications',
//   },
//   freeUserLimit: 200,
//   shopifyPaths: {
//     getCollections: '/getallcollection?shop=',
//     install: 'shopify?shop=',
//     updateEnabledDisableCollection: 'updateFiltredCategrory',
//     billingCreate: 'billing/create',
//     billingUpdate: 'billing/update',
//     billingCancel: 'billing/cancel',
//     getShippingZones: '/getShippingZones?shop=',
//     billingCreateOnUsage: 'billing/create/subscription/basedOnUsage',
//   },
//   InteractionModelAlexa:
//     'https://alexabackend-rcipzn3pdq-uc.a.run.app/create/interactionModel',
//   resizeSkillIcon: 'https://resizeiconalexa-rcipzn3pdq-uc.a.run.app/resize',
//   detectInteractionModelAlexa:
//     'https://alexabackend-rcipzn3pdq-uc.a.run.app/detect/interactionModel',
//   detectIntentAlexa:
//     'https://alexabackend-rcipzn3pdq-uc.a.run.app/detectIntent',
//   AlexaLoginUrl: 'https://alexabackend-rcipzn3pdq-uc.a.run.app/auth',
//   AlexaCreateSkill: 'https://alexabackend-rcipzn3pdq-uc.a.run.app/create/bot',
//   createIntentsAlexa:
//     'https://alexabackend-rcipzn3pdq-uc.a.run.app/create/intents',
//   AlexaAccountLinking:
//     'https://alexabackend-rcipzn3pdq-uc.a.run.app/create/accountLinking',
//   urlCreateBot:
//     'https://us-central1-dev-conversell.cloudfunctions.net/botApis/create-bot',
//   urlCloneThemeToshop:
//     'https://us-central1-dev-conversell.cloudfunctions.net/CloneFromThemeToShop',
//   stripeBaseURL:
//     'https://us-central1-dev-conversell.cloudfunctions.net/stripeSubscription',
//   stripePaths: {
//     listPlans: 'list-pricing',
//     listPlansByType: 'list-plans-by-type',
//     getPrimamryPlansByType: 'get-primary-plan-by-type',
//     getPlanByID: 'get-price-by-id',
//     install: 'shopify?shop=',
//     home: '?shop=',
//     createCustomer: 'create-customer',
//     createSubscription: 'create-subscription',
//     createCustomerPortalSession: 'create-customer-portal-session',
//     upgradeSubscription: 'upgrade-subscription',
//     cancelSubscription: 'cancel-subscription',
//     billingSessionUrl: 'billing-session-url',
//     getPlansByChannalTtype: '/get-plans-by-channal-type',
//   },
//   canals: [
//     {
//       name: 'Google Assistant',
//       id: 'google-assistant',
//       image:
//         'https://firebasestorage.googleapis.com/v0/b/dev-conversell.appspot.com/o/general%2Fgoogle-assistant.png?alt=media&token=a291850b-9114-4e38-863e-0cab85dd83f2',
//     },
//     {
//       name: 'Facebook Messenger',
//       id: 'messenger',
//       image:
//         'https://firebasestorage.googleapis.com/v0/b/dev-conversell.appspot.com/o/general%2Fmessenger_logo.png?alt=media&token=ef01e683-92ae-411a-96e4-52040e78f83e',
//     },
//   ],
//   verifyAuthState:
//     'https://us-central1-dev-conversell.cloudfunctions.net/conversellAuthentification/auth/getway/verify',
//   sendEmailApi:
//     'https://us-central1-dev-conversell.cloudfunctions.net/sendEmail',
//   actionWithoutConfig: [
//     'PAYLOAD_ABANDON_CART',
//     'PAYLOAD_BACK_TO_LIST',
//     'PAYLOAD_DEFAULT_RESPONSE',
//     'PAYLOAD_DELETE_CART',
//     'PAYLOAD_DELIVERY_ADRESS',
//     'PAYLOAD_FILTER',
//     'PAYLOAD_FUNCTIONALITY_NOT_AVAILABLE',
//     'PAYLOAD_KEEP_CART',
//     'PAYLOAD_OUT_OF_STOCK',
//     'PAYLOAD_REPEAT_ORDER',
//     'PAYLOAD_REPLAY_INFORMATION',
//     'PAYLOAD_TRACK_ORDER',
//     'PAYLOAD_SKIP',
//     'PAYLOAD_SIGNIN',
//     'PAYLOAD_SHOW_OPTIONS',
//     'PAYLOAD_SHOW_OPTIONS',
//   ],
//   ingestKnowledgeBase: 'https://ingest.dev.conversell.ai',
//   elgenKnowledgeBase: 'https://elgen.dev.conversell.ai',
//   createFunctionTemplate:
//     'https://us-central1-conversell-pfe.cloudfunctions.net/openAIChat/api/createFunction',
//   scheduleCronjobUrl:
//     'https://us-central1-dev-conversell.cloudfunctions.net/scheduleCronjob/start-cron',
//   simulationUrl:
//     'https://us-central1-dev-conversell.cloudfunctions.net/openAIChat/api/simulationModeDebug',
//   openAIChatApiBaseUrl:
//     'https://us-central1-dev-conversell.cloudfunctions.net/openAIChat',
//   modelsUrl: 'https://conversell-gateway-d5rr2qgy.uc.gateway.dev/models',
//   workspaceUrl: 'https://conversell-gateway-d5rr2qgy.uc.gateway.dev',
//   userManagerUrl:
//     'https://conversell-gateway-d5rr2qgy.uc.gateway.dev/usermanager/',
//   platformsManagerUrl:
//     'https://conversell-gateway-d5rr2qgy.uc.gateway.dev/platformsmanager',
//   botManagerUrl:
//     'https://conversell-gateway-d5rr2qgy.uc.gateway.dev/botmanager',
//   /** CallManager HTTP (SIP admin + hook-status). Cloud Run voice runtime. */
//   callManagerUrl: 'https://callbot-758489913965.us-central1.run.app',
//   callManager: 'https://conversell-gateway-d5rr2qgy.uc.gateway.dev',
//   /**
//    * ChannelManager root (POST /manage_channel). Used by the admin Policy Enforcement screen to
//    * replay a synthetic messaging_policy_enforcement notice through the real webhook path, so
//    * the journal row is still written by the backend rather than by the browser.
//    */
//   channelManagerUrl: 'https://channelmanager-758489913965.us-central1.run.app',
//   jambonzSipDomain: 'conversell.sip.jambonz.cloud',
//   //stripeManagerUrl: 'https://conversell-gateway-d5rr2qgy.uc.gateway.dev',
//   stripeManagerUrl: `https://stripemanager-rcipzn3pdq-uc.a.run.app`,
//   WidgetChatManager: 'https://conversell-gateway-d5rr2qgy.uc.gateway.dev',
//   KnowledgeBaseManager:
//     'https://conversell-gateway-d5rr2qgy.uc.gateway.dev/knowledge-base',
//   catalogManager: 'https://conversell-gateway-d5rr2qgy.uc.gateway.dev',
//   administratorManager:
//     'https://conversell-gateway-d5rr2qgy.uc.gateway.dev/admin',
//   plansWoocommerceSubscriptionUrl: {
//     createSubscriptionUrl:
//       'https://us-central1-dev-conversell.cloudfunctions.net/stripeSubscription/create-subscription',
//     updateSubscriptionUrl:
//       'https://us-central1-prodconversell.cloudfunctions.net/stripeSubscription/update-subscription',
//     cancelSubscriptionUrl:
//       'https://us-central1-prodconversell.cloudfunctions.net/stripeSubscription/cancel-subscription',
//   },
//   widgetIframeOrigin: 'https://widgetiframeconversell.firebaseapp.com',
//   localStorage: {
//     user: 'conversell-user',
//     secretKey: 'Conversell-Dashboard-2024-Secret-Key-Change-In-Production',
//   },
// };
export const devEnvironmentBase = environment;
